<template>
<div class="data-box">
  <h2>DATA</h2>
  <div v-if="store.imageUrl || store.predictedFup !== null || store.rowValues.some(val => val !== 0)" class="results">
  <div class="data-numerical">
      <div class="data-child"><div>  Free Fraction  (Fu) :  </div><div v-if="store.predictedFup != null">{{ store.predictedFup }}</div> <div v-else>could not retrieve fup for this Antibiotic</div></div>
      <div class="data-child"><div> Expected Free Concentration (mg/L) : </div> <div v-if="expectedConcentration != null">{{ expectedConcentration }}</div> <div v-else>cannot compute without fup</div></div>
      <div class="data-child ecoff-editor">
        <div>
          <strong>MIC / ECOFF</strong> (mg/L) :
          <span class="ecoff-source" :class="{ 'ecoff-source--override': isOverridden }">
            {{ isOverridden ? 'manual override' : (originalEcoff != null ? 'from EUCAST' : 'no EUCAST value') }}
          </span>
        </div>
        <div class="ecoff-input-group">
          <input
            type="number"
            step="any"
            min="0"
            v-model="ecoffInput"
            class="ecoff-input"
            placeholder="enter MIC"
            aria-label="MIC or ECOFF override"
          />
          <button
            v-if="isOverridden && originalEcoff != null"
            type="button"
            class="ecoff-reset"
            @click="resetEcoff"
            title="Restore the EUCAST ECOFF value"
          >
            ↺ reset
          </button>
        </div>
      </div>
      </div>
      <div v-if="store.currentAtbDataRow && store.currentAtbDataRow['Ctrough'] == '1'" style="margin-top:20px;display: flex;justify-content: space-between;width:100%;max-width:700px" >
        <div> desired standard interval of <strong>Total trough concentration</strong> (mg/L) for <strong>{{ store.modeAdmin }}</strong> :</div>
        <div>
          <template v-if="intervalTrough.min==null || intervalTrough.max == null">data unavailable for {{ store.modeAdmin }}</template>
          <template v-else>[{{ intervalTrough.min }} ; {{ intervalTrough.max }}] mg/L</template>
        </div>
      </div>

      <div v-if="store.currentAtbDataRow && store.currentAtbDataRow['Cpeak'] == '1'" style="margin-top:6px;display: flex;justify-content: space-between;width:100%;max-width:700px" >
        <div> desired standard interval of <strong>Peak concentration</strong> (mg/L) :</div>
        <div>
          <template v-if="intervalPeak.min==null || intervalPeak.max == null">data unavailable</template>
          <template v-else>[{{ intervalPeak.min }} ; {{ intervalPeak.max }}] </template>
        </div>
      </div>

      <div v-if="store.currentAtbDataRow && store.currentAtbDataRow['AUC'] == '1'" style="margin-top:6px;display: flex;justify-content: space-between;width:100%;max-width:700px" >
        <div> desired standard interval of <strong>24-hours AUC</strong> (mg.h/L) :</div>
        <div>
          <template v-if="intervalAUC.min==null || intervalAUC.max == null">data unavailable</template>
          <template v-else>[{{ intervalAUC.min }} ; {{ intervalAUC.max }}] mg.h/L</template>
        </div>
      </div>
   <div class="table-container">
    <div style="margin-bottom: 20px;font-size:25px">MIC Distribution</div>
    <div class="table-wrapper">
      <table class="table">
        <thead >
           <tr>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.002 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.004 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.008 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.016 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.03 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.06 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.125 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.25 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 0.5 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 1 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 2 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 4 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 8 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 16 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 32 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 64 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 128 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 256 </th>
              <th title="" data-toggle="tooltip" data-html="true" data-placement="top"> 512 </th>
              <th title="Distributions" data-toggle="tooltip" data-html="true" data-placement="top"> Distributions </th>
              <th title="Observations" data-toggle="tooltip" data-html="true" data-placement="top"> Observations </th>
              <th title="Consensus (T)ECOFF for the species/agent* on aggregated distributions:<br />- = less than 3 distributions;<br />ID = insufficient data;<br />( ) = TECOFF (3-4 distributions);<br />(( )) forced ECOFF for fewer than 3 distributions" data-toggle="tooltip" data-html="true" data-placement="top"> (T)ECOFF </th>
              <th title="Lower and upper confidence limit" data-toggle="tooltip" data-html="true" data-placement="top"> Confidence interval </th>
           </tr>
        </thead>
        <tbody>
           <tr>
              <td v-for="(value, index) in store.rowValues">{{ value }}</td>
           </tr>
        </tbody>
     </table>
    </div>
   </div>
   {{ store.errorMIC }}
   <div v-if="store.imageUrl" class="image-container">
     <img :src="store.imageUrl" alt="Fetched Image" class="responsive-image"/>
   </div>

  

</div>
<div v-else class="empty-data">
  select antimicrobial and organism !
</div>
</div>
</template>

<script setup>
import { computed, ref, watch } from "vue"
import { useTestStore } from "@/stores/testStore";
 

const store = useTestStore();
const expectedConcentration = computed(() => {
  if(store.predictedFup != null) {
    return parseFloat((store.measuredCon * store.predictedFup).toFixed(2));
  }
  else {
    return null
  }
}
);

const originalEcoff = computed(() => {
  const raw = store.rowValues[21];
  if (raw == null || raw === 0) return null;
  const cleaned = String(raw).replace(/[^\d.,-]/g, '').replace(',', '.');
  const n = parseFloat(cleaned);
  return isFinite(n) && n > 0 ? n : null;
});

const ecoffInput = computed({
  get() {
    if (store.ecoff === 0 || store.ecoff === 'ID' || store.ecoff == null) return '';
    return store.ecoff;
  },
  set(value) {
    if (value === '' || value == null) {
      store.ecoff = 0;
      return;
    }
    const n = parseFloat(value);
    store.ecoff = isFinite(n) && n > 0 ? n : 0;
  }
});

const isOverridden = computed(() => {
  if (originalEcoff.value == null) {
    return typeof store.ecoff === 'number' && store.ecoff > 0;
  }
  return typeof store.ecoff === 'number' && store.ecoff > 0 && store.ecoff !== originalEcoff.value;
});

const resetEcoff = () => {
  store.ecoff = originalEcoff.value ?? 0;
};


const intervalTrough = computed(() => { 
  let min = null;
  let max = null;
  if (!store.currentAtbDataRow) return { min, max };
  if (store.modeAdmin == "IVSE") {
    min = store.currentAtbDataRow["Cmin usuelle (Plateau_IVSE))"];
    max = store.currentAtbDataRow["Cmax usuelle (Plateau_IVSE))"];
    return  {min, max};
  } else {
    min = store.currentAtbDataRow["Cmin usuelle (Trough)"];
    max = store.currentAtbDataRow["Cmax usuelle (Trough)"];
    return {min, max};
  }
})

const intervalPeak = computed(() => {
  let min = null;
  let max = null;
  if (!store.currentAtbDataRow) return { min, max };
  min = store.currentAtbDataRow["Cmin usuel (peak)"];
  max = store.currentAtbDataRow["Cmax usuel (peak)"];
  return { min, max };
})

const intervalAUC = computed(() => {
  let min = null;
  let max = null;
  if (!store.currentAtbDataRow) return { min, max };
  min = store.currentAtbDataRow["AUCmin usuelle"];
  max = store.currentAtbDataRow["AUCmax usuelle"];
  return { min, max };
})


</script>

<style scoped>

.data-numerical {
  width: 100%;
  max-width: 500px;
}

.data-child {
  display: flex;
  justify-content: space-between;
  margin: 5px 0px;
}

.ecoff-editor {
  align-items: center;
  gap: 12px;
}

.ecoff-source {
  margin-left: 6px;
  font-size: 0.8em;
  color: #6c757d;
  font-style: italic;
}

.ecoff-source--override {
  color: #b8740b;
  font-weight: 600;
  font-style: normal;
}

.ecoff-input-group {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.ecoff-input {
  width: 30px;
  padding: 4px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.95em;
  text-align: right;
  -moz-appearance: textfield;
  appearance: textfield;
}

.ecoff-input::-webkit-outer-spin-button,
.ecoff-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.ecoff-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}

.ecoff-reset {
  position: absolute;
  left: 100%;
  margin-left: 6px;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 0.8em;
  color: #495057;
  cursor: pointer;
  white-space: nowrap;
}

.ecoff-reset:hover {
  background-color: #f1f3f5;
  border-color: #adb5bd;
}

.data-box {
  border: rgb(204, 161, 161) 3px solid;
  border-radius: 15px;
  margin: 0px 150px 0px 30px;
  resize: both;
  overflow: auto;
  min-width: 400px;
  min-height: 300px;
  width: 800px;
  height: 600px;
}



.results {
  display: flex;
  justify-content: start;
  flex-direction: column;
  padding: 10px 10px 50px 10px;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.table-container {
  margin-top: 20px;
  width: 100%;
}

.table-wrapper {
  overflow-x: auto;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.table {
  min-width: 100%;
  width: max-content;
  border-collapse: collapse;
  white-space: nowrap;
}

.table th,
.table td {
  padding: 8px 12px;
  border: 1px solid #ddd;
  text-align: center;
  min-width: 50px;
}

.table th {
  background-color: #f5f5f5;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1;
}

.image-container {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.responsive-image {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.empty-data {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin: 0px 0px 40px 0px;
}
</style>